import React from 'react';
import Modal from '../Modal';
import { Fournisseur } from '../../types/weighing';
import { ExclamationTriangleIcon, TrashIcon, BuildingOfficeIcon } from '@heroicons/react/24/outline';

interface DeleteSupplierModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  supplier: Fournisseur;
}

const DeleteSupplierModal: React.FC<DeleteSupplierModalProps> = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  supplier 
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Supprimer le fournisseur" size="md">
      <div className="space-y-6">
        {/* Icône d'avertissement */}
        <div className="flex justify-center">
          <div className="p-3 bg-red-100 rounded-full">
            <ExclamationTriangleIcon className="h-8 w-8 text-red-600" />
          </div>
        </div>

        {/* Message d'avertissement */}
        <div className="text-center">
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            Êtes-vous sûr de vouloir supprimer ce fournisseur ?
          </h3>
          <p className="text-sm text-gray-600">
            Cette action est irréversible et supprimera définitivement le fournisseur et toutes ses données associées.
          </p>
        </div>

        {/* Résumé du fournisseur à supprimer */}
        <div className="bg-gray-50 rounded-lg p-4">
          <div className="flex items-center space-x-3">
            <div className="p-2 bg-orange-100 rounded-lg">
              <BuildingOfficeIcon className="h-6 w-6 text-orange-600" />
            </div>
            <div className="flex-1">
              <h4 className="font-medium text-gray-900">{supplier.nom}</h4>
              <div className="text-sm text-gray-600 space-y-1 mt-1">
                {supplier.contact && (
                  <div>Contact: {supplier.contact}</div>
                )}
                {supplier.cooperative && (
                  <div>Coopérative: {supplier.cooperative}</div>
                )}
                {supplier.email && (
                  <div>Email: {supplier.email}</div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Avertissement supplémentaire */}
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
          <div className="flex items-start space-x-3">
            <ExclamationTriangleIcon className="h-5 w-5 text-yellow-600 mt-0.5" />
            <div className="text-sm text-yellow-800">
              <p className="font-medium">Attention :</p>
              <ul className="mt-1 list-disc list-inside space-y-1">
                <li>Toutes les transactions associées à ce fournisseur seront affectées</li>
                <li>Cette action ne peut pas être annulée</li>
                <li>Assurez-vous de sauvegarder toutes les informations importantes</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Boutons d'action */}
        <div className="flex justify-end space-x-3 pt-4 border-t border-gray-200">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
          >
            Annuler
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors flex items-center space-x-2"
          >
            <TrashIcon className="h-4 w-4" />
            <span>Supprimer définitivement</span>
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteSupplierModal;
